import { debounce } from '@fastcampus/browser-util';

export default (w, d) => {
  const init = () => {
    [...d.querySelectorAll('.fc-v-container')].forEach(($container) => {
      const onPlayer = () => {
        const $player = $container.querySelector('.fc-v-container__player');
        const { offsetTop, offsetHeight } = $container;
        const { pageYOffset, innerHeight } = w;
        const isVisible = pageYOffset + innerHeight >= offsetTop && pageYOffset <= offsetTop + offsetHeight;
        // console.log(isVisible, pageYOffset + innerHeight, offsetTop, pageYOffset, offsetTop + offsetHeight);

        // for iPhone
        $player.setAttribute('playsinline', '');

        if (!$player.loop) {
          $player.loop = true;
        }
        if (!$player.muted) {
          $player.muted = true;
        }

        if (isVisible) {
          if ($player.paused) {
            $player.play();
          }
        } else {
          $player.pause();
        }
      };
      w.addEventListener('scroll', debounce(onPlayer, 200));

      onPlayer();
    });
  };

  setTimeout(() => {
    init();
  }, 3000);
};
